import { render } from "./UploadHeader.component.vue?vue&type=template&id=c61f6300&scoped=true&ts=true"
import script from "./UploadHeader.component.vue?vue&type=script&lang=ts"
export * from "./UploadHeader.component.vue?vue&type=script&lang=ts"

import "./UploadHeader.component.vue?vue&type=style&index=0&id=c61f6300&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61f6300"]])

export default __exports__